export default "/images/8f075d1404f0b7ba97224cda3862a563.avif";